import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
export default function CaseSearch() {
    const handleChange = (event: SelectChangeEvent) => {
        console.log(event.target.value as string);
    };

    return (
        <Stack spacing={2}>
            <TextField
                id="outlined-basic"
                label="Case Sequence Number"
                variant="outlined"
            />
            <Button variant="contained">Search</Button>
            <InputLabel id="demo-simple-select-label">
                Matching Cases Found
            </InputLabel>
            <Select
                labelId="demo-simple-select-label"
                label="Age"
                onChange={handleChange}
            >
                <MenuItem value={10}>Ten</MenuItem>
                <MenuItem value={20}>Twenty</MenuItem>
                <MenuItem value={30}>Thirty</MenuItem>
            </Select>
        </Stack>
    );
}
